/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum LogicalOperator {
  And = 'And',
  Or = 'Or',
  Nor = 'Nor'
}
